import View from "./View.js";
import previewView from "./previewView.js";
import icons from "url:../../img/BBA25-sprite.svg"; // Parcel 2

class FinalistsSelectView extends View {
	_parentElement = document.querySelector(".finalists");

	addHandlerClick(handler) {
		this._parentElement.addEventListener("click", function (e) {
			const categoryBtn = e.target.closest(".category");
			if (!categoryBtn) return;
			e.preventDefault();
			this.querySelector(".category--active")?.classList.remove("category--active");
			categoryBtn.classList.add("category--active");

			const categoryID = categoryBtn.dataset.id;
			handler(categoryID);
		});
	}
}

export default new FinalistsSelectView();
